<template>
  <div class="background_team">
    <div class="team_index_text">
      <p style="font-size: 22px">我们的团队</p>
      <p style="font-size: 27px;">我们是同行者 分享暗淡与荣光</p>
      <p>————</p>
      <p style="font-size: 12px">SIG企业文化的核心，是激发员工的创造力，</p>
      <p style="font-size: 12px">鼓励员工挑战自身极限。在投资对象中，</p>
      <p style="font-size: 12px">我们同样看中有创造力、理解快速发展的中国经济、</p>
      <p style="font-size: 12px">兼备战略眼光和执行力的创业团队。</p>
      <div class="index_down">
        <a-button type="ghost" shape="circle-outline" size="large">
          <template v-slot:icon>
            <DownOutlined>
            </DownOutlined>
          </template>
        </a-button>
      </div>
    </div>
  </div>
</template>

<script>
import {DownOutlined} from '@ant-design/icons-vue'

export default {
  name: "Team_index_m",
  components: {
    DownOutlined,
  },
  setup() {
    const next_page = () => {
      document.documentElement.scrollBy({
        top: window.innerHeight * 92 / 100,
        behavior: "smooth",
      })
    }
    return {next_page}
  }
}
</script>

<style scoped>
.team_index_text {
  padding-top: 30vh;
  text-align: center;
}

.background_team {
  background-image: url("../../../assets/background/index_team.jpg");
  height: 100vh;
  background-repeat: no-repeat;
  background-position: center;
  background-size: auto 100%;
  margin: 0;
}


</style>